// src/utils/addTextToImage.js

export const AddTextToImage = async (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = async () => {
        const { latitude, longitude } = await getCurrentLocation();
        const locationName = await getLocationName(latitude, longitude);
        const now = new Date();
        const dateTime = now.toLocaleString();

        // Footer size
        const boxHeight = img.height * 0.15;
        const padding = boxHeight * 0.12;
        const radius = boxHeight * 0.15;

        const fontBig = boxHeight * 0.18;
        const fontSmall = boxHeight * 0.18;
        const lineGap = boxHeight * 0.22;

        const boxWidth = img.width;
        const boxX = 0;
        const boxY = img.height - boxHeight;

        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");

        // Draw image
        ctx.drawImage(img, 0, 0);

        // Footer background
        ctx.fillStyle = "rgba(0,0,0,0.60)";
        ctx.beginPath();
        ctx.moveTo(boxX + radius, boxY);
        ctx.lineTo(boxX + boxWidth - radius, boxY);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius);
        ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius);
        ctx.quadraticCurveTo(
          boxX + boxWidth,
          boxY + boxHeight,
          boxX + boxWidth - radius,
          boxY + boxHeight
        );
        ctx.lineTo(boxX + radius, boxY + boxHeight);
        ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius);
        ctx.lineTo(boxX, boxY + radius);
        ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY);
        ctx.fill();

        // Text
        let textX = padding;
        let textY = boxY + fontBig + padding * 0.3;

        ctx.fillStyle = "white";
        ctx.font = `${fontBig}px Arial`;
        ctx.fillText(locationName, textX, textY);

        textY += lineGap;
        ctx.font = `${fontSmall}px Arial`;
        ctx.fillText(`Lat: ${latitude}, Long: ${longitude}`, textX, textY);

        textY += lineGap;
        ctx.fillText(dateTime, textX, textY);

        textY += lineGap;
        ctx.fillText("Note: Captured by BFI Map Camera", textX, textY);

        canvas.toBlob((blob) => {
          resolve(
            new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            })
          );
        }, file.type);
      };
    };
  });
};

/* ---------------- helpers ---------------- */

const getCurrentLocation = () => {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        });
      },
      () => resolve({ latitude: null, longitude: null })
    );
  });
};

const getLocationName = async (lat, lon) => {
  try {
    if (!lat || !lon) return "Unknown Location";

    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
    );
    const data = await response.json();
    return data?.display_name || "Unknown Location";
  } catch {
    return "Unknown Location";
  }
};
